<template>
  <div class="select-file" v-if="list.length > 0">
    <!-- <UploadOss ref="upload" @click.native="saveIndex = 0" v-if="list.length === 1" upload_type="ordinary" type="attachment" @onUploadProgress="onUploadProgress"> -->
    <span class="select-button" @click="uploadFile(0)" v-if="list.length === 1">
      <i class="icon iconfont iconicon_annex2"></i>
    </span>
    <!-- </UploadOss> -->
    <el-dropdown v-else size="small" :trigger="list.length > 1 ? 'hover' : 'click'" placement="bottom" :show-timeout="100">
      <span class="select-button">
        <i class="icon iconfont iconicon_annex2"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="del" v-for="(item,index) in list" :key="item.id" @click.native="uploadFile(index)">
          <!-- <UploadOss ref="upload" upload_type="ordinary" type="attachment" @onUploadProgress="onUploadProgress"> -->
          <toolTip maxWidth="200px" :title="item.component_name_in_template">
            上传{{item.component_name_in_template}}
          </toolTip>
          <!-- </UploadOss> -->
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import projectConfig from '@config/projectConfig'
import { Cookie } from '@/utils/utils'
import UploadOss from '@/components/uploadOss'
import bus from '@/bus'
import { mapState } from 'vuex'
export default {
  props: ['editData'],
  watch: {
    dataset: {
      handler() {
        this.list = this.dataset?.task_template_content?.template_standard_components.filter(res => res.component_code === 'TaskComponent.Attachment.Attachment' && res.is_show === 1) || []
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    UploadOss
  },
  computed: {
    headers() {
      return { 'X-TOKEN': Storage.get('wfUserInfo').token }
    },
    ...mapState('template/template', {
      dataset: state => state.dataset
    }),
  },
  data() {
    return {
      list: [],
      projectConfig: projectConfig,
      fileList: [],
      saveIndex: 0
    }
  },
  methods: {
    onUploadProgress(file, files) {
      if (file.percentage === 100) {
        this.success(file)
      }
    },
    handleCommand() {

    },
    beforeAvatarUpload(file) {
      let config = this.getTempConfig(this.list[this.saveIndex])
      let fileType = config.file_ext
      let arr = file.name.split('.')
      const isType = fileType.indexOf(arr[arr.length - 1].toLowerCase()) > -1
      const isLt2M = file.size < config.file_size;
      if (!isType) {
        this.$message.error('上传附件格式不对!');
      } else if ((file.size / Math.pow(1024, 2)).toFixed(2) > 50) {
        this.$message.error(`文件上传最高限制为50MB，请上传50MB以下的文件！`);
      } else if (!isLt2M) {
        this.$message.error(`该文件大小超过上传限制，请上传【${this.getfilesize(config.file_size)}】以下的文件!`);
      }
      return Boolean(isType) && Boolean(isLt2M)
    },
    getfilesize(size) {
      if (!size) return "";
      var num = 1024.00; //byte
      if (size < num)
        return size + "B";
      if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + "KB"; //kb
      if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
      if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
      return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    },
    success(file) {
      this.$emit('change', {
        data: {
          attachment_name: file.attachment_name,
          attachment_link: file.attachment_link,
          attachment_sign: file.attachment_sign,
          attachment_type: file.attachment_type,
          attachment_size: file.attachment_size,
        },
        id: file.id,
        form: this.getketText(this.list[this.saveIndex])
      })
    },
    getketText(item, fliter) {
      let strKey = item.component_code.split('.').join('-')
      let text = strKey + '-id' + item.id
      if (fliter && !item.component_config_in_template.is_require) {
        return ''
      }
      return text
    },
    getTempConfig(item) {
      let params = {
        ...item.component_config_in_template,
        component_desc_in_template: item.component_desc_in_template,
        component_name_in_template: item.component_name_in_template,
        component_code: item.component_code
      }
      return params
    },
    uploadFile(idx) {
      this.saveIndex = idx
      bus.$emit('selectUpload', this.list[idx].id)
    }
  }
}
</script>
<style lang="scss">
.select-file-upload {
  display: flex;
  align-items: center;
  .el-upload-dragger {
    height: auto;
    width: auto;
    border: 0 none;
    text-align: left;
    background-color: initial;
  }
  .upload-demo {
    margin-top: 16px;
  }
  .el-upload-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .el-upload-list__item-preview {
    display: flex;
    align-items: center;
  }
}
.select-file {
  .select-button {
    i {
      font-size: 15px;
      padding: 4px;
      border-radius: 4px;
      margin-left: 0px !important;
      &:hover {
        background-color: rgba(32, 32, 32, 0.08);
        color: #2682ff;
      }
    }
  }
}
</style>
